import { Divider, Row } from 'antd';
import CarouselSection from './CarouselSection';
import Footer from './Footer';
import QualitySection from './QualitySection';
import PluginsSection from './PluginsSection';
import MarqueeSection from './MarqueeSection';
import Bots from '~/pages/WorkflowMgr/Bots/list';

import './index.less';
import { useEffect } from 'react';
import { getLoginModalStore } from '~/components/LoginModal/store';
import { useSEO } from '~/hooks/useSEO';

const HomePage = () => {
  useSEO({
    title: '简创AIGC - AI视频创作平台',
    description:
      '简创AIGC是一个领先的AI视频创作平台，提供智能视频编辑、剪辑、特效添加等功能，帮助用户快速制作高质量视频内容。',
    keywords:
      'AI视频创作, 视频编辑, 智能剪辑, AI剪辑, 批量剪辑, AI生成, 视频特效, 简创AIGC, 开源剪映小助手capcut-mate',
    author: '逗赛科技',
    robots: 'index, follow',
    ogTitle: '简创AIGC - AI视频创作平台',
    ogDescription:
      '简创AIGC是一个领先的AI视频创作平台，提供智能视频编辑、剪辑、特效添加等功能，帮助用户快速制作高质量视频内容。',
    ogUrl: 'https://jcaigc.cn/',
    twitterCard: 'summary_large_image',
    twitterTitle: '简创AIGC - AI视频创作平台',
    twitterDescription:
      '简创AIGC是一个领先的AI视频创作平台，提供智能视频编辑、剪辑、特效添加等功能，帮助用户快速制作高质量视频内容。',
  });

  useEffect(() => {
    getLoginModalStore().open = false;
  }, []);
  return (
    <div className="home-page overflow-hidden-x">
      <CarouselSection />
      <section className="home-bots-section">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="fire"
                className="svg-inline--fa fa-fire daily-workflows-fire-icon"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"
                ></path>
              </svg>
              每日推荐工作流
            </h2>
            <p className="section-subtitle">精选优质智能体，提升您的AI创作效率</p>
          </div>
          <Row className="px-[20px] pt-2 pb-4 m-0" gutter={[16, 16]}>
            <Bots isTopBots={true} />
          </Row>
        </div>
      </section>
      <PluginsSection />
      <QualitySection />
      <MarqueeSection />
      <Divider className="m-0" />
      <Footer />
    </div>
  );
};

export default HomePage;
